import { styled } from '@mui/material'
import { DateTimePicker } from '@mui/x-date-pickers'

const StyledDateTimePicker = styled(DateTimePicker)({
    width: '100%',
    height: '40px',
    '& .MuiSvgIcon-root': {
        color: '#08294e',
        marginRight: '8px',
    },
    '.MuiOutlinedInput': {
        border: 0,
        outline: '1px solid rgba(140, 140, 140, 1)',
    },
    '& .MuiInputBase-input': {
        padding: 0,
    },
    '& .MuiFormHelperText-root': {
        paddingBottom: '8px',
        color: 'rgba(196, 44, 33, 1)',
    },
    '& .Mui-disabled': {
        WebkitTextFillColor: 'rgba(0, 0, 0, 0.38) !important',
        opacity: 1,

        pointerEvents: 'none',
        '& .MuiSvgIcon-root': {
            color: 'rgba(0, 0, 0, 0.38)', // Greyed-out icon
        },
        '& .MuiOutlinedInput-notchedOutline': {
            borderColor: 'rgba(0, 0, 0, 0.38)',
        },
    },
})

export default StyledDateTimePicker
